import { useEffect, useState } from "react";

// How long a deal has got left, as the UI shows it: the overview's ongoing-deal panel and the
// countdown in the deal-flow header both read from here, so the two can never disagree.
//
// Deliberately free of imports beyond React — the server read lives in dealStatus.js. Pulling
// the API client in here would drag axios (ESM) into every component that only wants to format
// a number, which this project's Jest cannot load.

export const formatRemaining = (seconds) => {
  const s = Math.max(0, Number(seconds) || 0);
  const mm = String(Math.floor(s / 60)).padStart(2, "0");
  const ss = String(s % 60).padStart(2, "0");
  return `${mm}:${ss}`;
};

// Counts down from a server-supplied reading, so what is displayed depends only on how long ago
// that reading was taken — never on the browser's own clock or time zone.
export function useCountdown(remainingSeconds, readAt) {
  const base = Number.isFinite(remainingSeconds) ? remainingSeconds : null;
  const from = readAt || Date.now();
  const calc = () => (base === null ? null : Math.max(0, base - Math.floor((Date.now() - from) / 1000)));
  const [remaining, setRemaining] = useState(calc);
  useEffect(() => {
    if (base === null) {
      setRemaining(null);
      return undefined;
    }
    setRemaining(calc());
    const id = setInterval(() => setRemaining(calc()), 1000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [base, from]);
  return remaining;
}
